import React, { useEffect } from 'react';
import QRCode from 'qrcode.react';
import { fileHandlerUrl } from '../../../utils/consts/server';
const QrCode = ({
  url,
  value,
  renderAs = 'canvas' || 'svg',
  size = 150,
  errorCorrectionLevel = 'H' ||
    'L' ||
    'M' ||
    'Q' ||
    'high' ||
    'low' ||
    'medium' ||
    'quartile',
  imgWidth = 40,
  imgHeight = 40,
  imgSrc,
  imgX = size / 2 - imgHeight / 2,
  imgY = size / 2 - imgWidth / 2,
  imgBg = false,
}) => {
  return (
    <QRCode
      renderAs={renderAs}
      size={size}
      level={errorCorrectionLevel}
      onClick={() => {
        url && window.open(url, '_blank').focus();
      }}
      value={value}
      imageSettings={{
        src: require('../../../content/images/elements/logo.png'),
        // src: imgSrc
        //   ? `${fileHandlerUrl}/file/download/${imgSrc}`
        //   : require("../../content/images/icon/logo.png"),
        height: imgHeight,
        width: imgWidth,
        excavate: imgSrc ? imgBg : false,
        x: imgX,
        y: imgY,
      }}
    />
  );
};

export default QrCode;
// how to use
//  import Qr from 'component address'
{
  /* <Qr
url="test/url to destination url" //url to go after click
value="morteza ahmadi 1234" //value  you want encrypt in qr code
imgSrc="logo.png" //image name from "content/images/icon" folder
 renderAs = "canvas" , // render as
  size = 150, //qr code size
  errorCorrectionLevel = "H" , //error Correction Level 
  imgWidth = 40, //logo wifth
  imgHeight = 40, //logo height
  imgX = size / 2 - imgHeight / 2,// place of image in x
  imgY = size / 2 - imgWidth / 2,// place of image in y
  imgBg = false,// set white bg to logo
/> */
}

// ----------------------------------
// create by Morteza Ahmadi
// import React, { useEffect } from "react";
// import QRCode from "qrcode";

// const QrCode = ({
//   url,
//   value,
//   size = 150,
//   errorCorrectionLevel = "H" ||
//     "L" ||
//     "M" ||
//     "Q" ||
//     "high" ||
//     "low" ||
//     "medium" ||
//     "quartile",
//   imgWidth = 40,
//   imgHeight = 40,
//   imgSrc,
//   imgPlace = "c" || "tl" || "tr" || "bl" || "br",
//   imgBg = false || true,
// }) => {
//   useEffect(() => {
//     console.log({
//       url,
//       value,
//       size,
//       errorCorrectionLevel,
//       imgWidth,
//       imgHeight,
//       imgSrc,
//       imgPlace,
//       imgBg,
//     });
//     let canvas = document.getElementById("canvas");
//     QRCode.toCanvas(
//       canvas,
//       value,
//       { errorCorrectionLevel, margin: 0 },
//       (error) => {
//         if (error) console.error(error);
//       }
//     );
//   }, []);

//   const renderLogos = (src) => {
//     try {
//       return require(`../../content/images/icon/${src}`);
//     } catch (error) {
//       return require(`../../content/images/icon/logo.png`);
//     }
//   };
//   return (
//     <div
//       className={`d-flex cursor-pointer ${
//         imgPlace === "tl"
//           ? "justify-content-start align-items-start"
//           : imgPlace === "tr"
//           ? "justify-content-end align-items-start"
//           : imgPlace === "bl"
//           ? "justify-content-start align-items-end"
//           : imgPlace === "br"
//           ? "justify-content-end align-items-end"
//           : imgPlace === "c"
//           ? "justify-content-center align-items-center"
//           : ""
//       }`}
//       style={{ width: `${size}px`, height: `${size}px`, direction: "ltr" }}
//       onClick={() => {
//        url && window.open(url, "_blank").focus();
//       }}
//     >
//       {imgSrc && (
//         <img
//           style={{
//             position: "absolute",
//             height: `${imgHeight}px`,
//             width: `${imgWidth}px`,
//             background: `${imgBg ? "white" : "none"}`,
//           }}
//           src={renderLogos(imgSrc)}
//           alt={imgSrc}
//         />
//       )}
//       <canvas className="w-100 h-100 m-0 p-0" id="canvas" />
//     </div>
//   );
// };

// export default QrCode;
